import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getBaseFormComponentDirectiveProvider } from '@app/shared/components/forms/base-form-component';
import { ProductCentreLogicService } from '@app/logic/product-centre/product-centre.logic.service';
import { provideParentForm } from '@app/shared/providers/provide-parent-form.provider';
import { BaseInputFindDirective } from '@app/shared/components/forms/input-find/base-input-find.directive';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { IProductCentreDocumentDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { ProductCentreFindDialogComponent } from '@app/shared/components/forms/individual/product-centre-find/product-centre-find-dialog/product-centre-find-dialog.component';
import { IExistingSlotItem } from '@app/views/products/tabs/product-centre/product-centre-tab.component';
import { take } from 'rxjs';

@Component({
    selector: 'cb-product-centre-find',
    templateUrl: '../../input-find/base-input-find.directive.html',
    styleUrls: ['../../input-find/base-input-find.directive.scss'],
    providers: [
        getBaseFormComponentDirectiveProvider(ProductCentreFindComponent),
        ProductCentreLogicService,
        provideParentForm()
    ],
    standalone: false
})
export class ProductCentreFindComponent extends BaseInputFindDirective {
    @Input() public readonly initializeSearchOnLoad = true;
    @Input() public readonly categoryIdFilter: number;
    @Input() public readonly activeOnly: boolean;
    @Input() public readonly businessEntityIdsToFilterBy: Set<number>;
    @Input() public readonly businessEntityIdsToSortBy: Set<number>;
    @Input() public readonly restrictedBusinessEntityIds: Set<number>;
    @Input() public readonly existingSlotItem: IExistingSlotItem;
    @Input() public readonly showCurrentProduct: boolean = false;
    @Input() public readonly currentProductTitle: string;
    @Input() public readonly hideNationalRate: boolean = false;
    @Input() public readonly ignoreTierBasedSorting: boolean = false;

    @Output() public readonly productSelected = new EventEmitter<IProductCentreDocumentDto>();

    protected _myDialog = ProductCentreFindDialogComponent;

    constructor(
        public readonly dialogRef: MatDialog,
        public readonly router: Router,
        public readonly navigationService: NavigationService,
        private readonly cbDialog: CbDialogService
    ) {
        super();
    }

    public clear(): void {
        super.clear();
        this.text = '';
    }

    public openSearchDialog = (): void => {
        this.cbDialog
            .open(this._myDialog, {
                minWidth: '80%',
                minHeight: '95%',
                data: {
                    extraSearchParams: this.searchParams,
                    activeOnly: this.activeOnly,
                    initializeSearchOnLoad: this.initializeSearchOnLoad,
                    categoryIdFilter: this.categoryIdFilter,
                    businessEntityIdsToFilterBy: this.businessEntityIdsToFilterBy,
                    businessEntityIdsToSortBy: this.businessEntityIdsToSortBy,
                    existingSlotItem: this.existingSlotItem,
                    hideNationalRate: this.hideNationalRate,
                    showCurrentProduct: this.showCurrentProduct,
                    currentProductTitle: this.currentProductTitle,
                    restrictedBusinessEntityIds: this.restrictedBusinessEntityIds,
                    ignoreTierBasedSorting: this.ignoreTierBasedSorting
                }
            })
            .afterClosed()
            .pipe(take(1)).subscribe((result: IProductCentreDocumentDto | false) => {
                if (result) {
                    this.productSelected.emit(result);
                }
            });
    };
}
